import { ButtonPosition } from '@/common/manager/position/button-position';
import cloneDeep from 'lodash/cloneDeep';
export const config = {
    value: 'arraySubAreaCardCopy',
    position: [ButtonPosition.arraySubAreaCardOperate],
    action: (config) => {
        const { arrayBaseField: field, arrayBaseFieldIndex: index } = config || {};
        if (!field)
            return;
        if (field.disabled === true || field.pattern !== 'editable')
            return;
        field.insert(index + 1, cloneDeep(field.value[index]));
    },
};
